export default __webpack_public_path__ + "static/media/gcs.debdf731.svg";